/* eslint-disable jsx-a11y/anchor-is-valid */
import {
  Box, Link, Paper, Popper, Typography,
} from '@mui/material';
import React from 'react';

function CustomPoper({
  labelPopper, labelLink, setOpenModal, ...param
}) {
  return (
    <Popper {...param}>
      <Box {...param} />
      <Paper style={{ height: '100%' }}>
        <Typography
          style={{ padding: '1rem', color: 'gray' }}
        >
          {labelPopper}
          {' '}
          <Link
            style={{ cursor: 'pointer' }}
            color="primary"
            onMouseDown={setOpenModal}
          >
            {`${labelLink} +`}
          </Link>
        </Typography>
      </Paper>
    </Popper>
  );
}

export default CustomPoper;
